import { type ReactNode } from 'react';
import Cropper, {
  type Area,
  type MediaSize,
  type Point,
} from 'react-easy-crop';
import { Button } from '@/components/ui/button';
import { CropOverlay } from './crop-overlay';

export { ZoomSlider } from './zoom-slider';

export type CropWired = {
  crop: Point;
  zoom: number;
  minZoom: number;
  setCrop: (p: Point) => void;
  setZoom: (z: number) => void;
  onCropComplete: (_: Area, px: Area) => void;
  onMediaLoaded: (s: MediaSize) => void;
};

export function Frame({ src, w }: { src: string; w: CropWired }): ReactNode {
  return (
    <div className="relative mx-auto aspect-[9/16] w-[13rem] overflow-hidden rounded-lg sm:w-[15rem]">
      <Cropper
        image={src}
        crop={w.crop}
        zoom={w.zoom}
        minZoom={w.minZoom}
        maxZoom={4}
        aspect={9 / 16}
        showGrid={false}
        onCropChange={w.setCrop}
        onZoomChange={w.setZoom}
        onCropComplete={w.onCropComplete}
        onMediaLoaded={w.onMediaLoaded}
      />
      <div className="pointer-events-none absolute inset-0">
        <CropOverlay />
      </div>
    </div>
  );
}

export function Footer({
  onCancel,
  onConfirm,
  busy,
}: {
  onCancel: () => void;
  onConfirm: () => void;
  busy: boolean;
}): ReactNode {
  return (
    <div className="flex justify-end gap-sm">
      <Button variant="ghost" size="sm" onClick={onCancel}>
        Cancelar
      </Button>
      <Button size="sm" disabled={busy} onClick={onConfirm}>
        {busy ? 'Procesando...' : 'Aplicar recorte'}
      </Button>
    </div>
  );
}
